import { bankAccountFormFields } from './bank-account-form.fields';
import { getAccountToValidate } from './bank-account-form.validators';

const translateAccountTypeValue = (accountTypeValue, isCEF = false) => {
  const cefTranslator = {
    '022': 'cp',
    '003': 'cc',
  };
  return isCEF ? cefTranslator[accountTypeValue] : accountTypeValue;
};

export const bankAccountPayloadSerializer = ({ cnpj, isCEF = false, sellerId, values }) => {
  const { ACCOUNT_TYPE, AGENCY, BANK, BANK_ACCOUNT, BANK_ACCOUNT_DIGIT } = bankAccountFormFields;
  const accountTypeValue = values[ACCOUNT_TYPE]?.value;
  const bankAccount = getAccountToValidate({
    account: values[BANK_ACCOUNT],
    accountType: accountTypeValue,
    digit: values[BANK_ACCOUNT_DIGIT],
    isCEFAccount: isCEF,
  });

  return {
    account_type: translateAccountTypeValue(accountTypeValue, isCEF),
    agency: values[AGENCY],
    bank_account: bankAccount,
    bank: values[BANK].value,
    cnpj,
    seller_id: sellerId,
  };
};
